import React from "react";
import { apiRoutes } from "../../../hooks/apiClient";
import RoteiroPaginatedView from "../../../components/UI/PaginatedView/RoteiroPaginatedView";
import funcionalidades from "../../../context/AuthContext.funcionalidades";

const columns = [
  {
    name: "Sigla",
    selector: "sigla",
    width: "20%",
    sortable: true,
  },
  {
    name: "Nome",
    selector: "nome",
    width: "60%",
    sortable: true,
  },
  {
    name: "Situação",
    selector: "textoSituacao",
    width: "160px",
    sortable: true,
    center: true,
  },
];

const ConsultaRoteiro = ({ history, match }) => (
  <RoteiroPaginatedView
    title="Roteiro Ação Fiscal"
    keyField="sequencialRoteiro"
    descriptionField="nome"
    defaultSearch
    defaultSearchPlaceholder="Digite a descrição"
    queryService={apiRoutes.fiscalizacao.parametrizacao.consultaRoteiro}
    deleteService={apiRoutes.fiscalizacao.parametrizacao.excluiRoteiro}
    editRoute={`${match.url}/form`}
    columns={columns}
    permissionDelete={funcionalidades.roteiro.deletar}
    permissionInsert={funcionalidades.roteiro.inserir}
    history={history}
  />
);

export default ConsultaRoteiro;
